module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"in_use":"In use","remove":"Remove","set_default":"Set as default"},"th":{"in_use":"กำลังใช้งาน","remove":"ลบ","set_default":"ตั้งเป็นค่าเริ่มต้น"}}')
  delete Component.options._Ctor
}
